const config = {
    apiUrl: location.hostname !== 'localhost' ? `${location.origin}/api.php` : 'https://kreator.editello.com/api.php'
}

export default {
    getImages,
};

function getImages() {

    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}?action=getImages`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}